import { ChangeEvent } from 'react'

export const comissionPercentage = (value: number, comission: number) => {
  const percentage = (comission * 100) / value
  if (!percentage) return ''
  return `(${parseFloat(percentage.toFixed(1))}%)`
}

export const formatPercentage = (value: number) => {
  const _value = value > 10000 ? 100 : value / 100
  return _value.toFixed(2)
}

export const percentageMask = (e: ChangeEvent<HTMLInputElement>) => {
  const value = Number(e.target.value.replace(/\D/g, '') || 0)

  e.target.value = formatPercentage(value)
}
